import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useBaseUrl } from '../Contexts/BaseUrlContext';

const Header = ({ category, title }) => {
  const navigate = useNavigate();
  // const { baseUrl } = useBaseUrl();

  // useEffect(() => {
  //   const checkAuth = async () => {
  //     try {
  //       const formData = new FormData();
  //       formData.append('op', 'auth-check'); // Use 'op' to match Login.jsx convention

  //       const response = await axios.post(`http://localhost/video_player/video_api.php`, formData, {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: `Bearer ${localStorage.getItem('authToken')}`, // Include token if required
  //         },
  //         withCredentials: true,
  //       });

  //       console.log('Auth Check Response:', response.data);

  //       // Adjust based on actual API response structure
  //       if (response.data.status !== 'success') {
  //         navigate('/login');
  //       }
  //     } catch (error) {
  //       console.error('Auth Check Error:', error.response?.data || error.message);
  //       // Redirect to login on any error (e.g., network error, invalid token)
  //       navigate('/login');
  //     }
  //   };

  //   checkAuth();
  // }, [navigate, baseUrl]); // Include navigate and baseUrl in dependencies
 useEffect(() => {
  const toke = localStorage.getItem('authToken');
  if(toke === null || toke === undefined || toke === '') {
    navigate('/login');
  }
 },[]);

  return (
    <div className="mb-10">
      <p className="text-gray-400">{category}</p>
      <p className="text-3xl font-extrabold tracking-tight text-slate-900">{title}</p>
    </div>
  );
};

export default Header;